export default __webpack_public_path__ + "static/contact-969fae72e39899ab4c1203923b65bd43.webp";